<div class="col-12 col-lg-8">
    <!-- <h2 class="mb-4"> {{config.header}} </h2>
  <ng-container *ngFor="let desc of config.descriptions">
    <p>{{desc}}</p>
  </ng-container> -->
    <div *ngIf="config">
        <p *ngIf="config?.firstName" class="d-flex border-bottom">
            <span class="w-50"><strong>Όνομα</strong></span
            ><span class="w-50">{{ config.firstName }}</span>
        </p>
        <p *ngIf="config?.lastName" class="d-flex border-bottom">
            <span *ngIf="(config?.individual === false);else surname" class="w-50"><strong>Επωνυμία</strong></span>
            <ng-template #surname><span class="w-50"><strong>Επώνυμο</strong></span></ng-template>
            <span class="w-50">{{ config.lastName }}</span>
        </p>
        <p *ngIf="config?.companyName" class="d-flex border-bottom">
            <span class="w-50"><strong>Επωνυμία Εταιρείας</strong></span
            ><span class="w-50">{{ config.companyName }}</span>
        </p>
        <p class="d-flex border-bottom">
            <span class="w-50"><strong>Α.Φ.Μ.</strong></span
            ><span class="w-50">{{ config.taxNumber }}</span>
        </p>
        <p *ngIf="config?.selectedRole == 'NOTARY' && config?.notaryUniqueId " class="d-flex border-bottom">
            <span class="w-50"><strong>Μοναδικός Κωδικός</strong></span
            ><span class="w-50">{{ config.notaryUniqueId }}</span>
        </p>        
        <!-- <p
            class="d-flex border-bottom"
            *ngIf="config.selectedRole === 'NOTARY'"
        >
            <span class="w-50"
                ><strong>Αριθμός Μητρώου Συμβολαιογράφου</strong></span
            ><span class="w-50">{{ config.notaryRegId }}</span>
        </p> -->
    </div>
</div>
